export default __webpack_public_path__ + "static/media/DNo.13-1.93199fed.jpg";